// @ts-nocheck
import { useState } from "react";
import { NameSearch } from "../../Components/NameSearch";
import { filterByName } from "../../Utils/nameSearch";
import {
  Box,
  Button,
  SimpleGrid,
  Skeleton,
  Text,
  Icon,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import { PlayerCard } from "../../Components/PlayerCard";
import Layout from "../../Components/Layout";
import { useHome } from "./userHome";
import { FaFutbol, FaTrophy } from "react-icons/fa";
import "./ranking.css";

export const Home = (): JSX.Element => {
  const {
    error, loading, players, ownGoals, ownGoalsLoading,
    ownGoalsError, onTabChange, retryOwnGoals,
  } = useHome();
  const isShowPlayers = true;
  const [search, setSearch] = useState("");
  // Preserve the backend order and original positions when filtering names.
  const visibleScorers = filterByName(
    (players?.data ?? []).map((player, index) => ({ ...player, rankingPosition: index + 1 })),
    search, (player) => player.user_name,
  );
  const visibleOwnGoals = filterByName(
    (ownGoals ?? []).map((player, index) => ({ ...player, rankingPosition: index + 1 })),
    search, (player) => player.user_name,
  );

  return (
    <Layout title="Ranking por Gols">
      {isShowPlayers ? (
        <Tabs variant="unstyled" className="ranking-tabs" w="full" onChange={onTabChange}>
          <TabList className="ranking-tabs__list" aria-label="Tipo de ranking">
            <Tab className="ranking-tabs__tab">
              <FaTrophy aria-hidden="true" />
              <span>Artilheiros</span>
            </Tab>
            <Tab className="ranking-tabs__tab">
              <FaFutbol aria-hidden="true" />
              <span>Gols Contra</span>
            </Tab>
          </TabList>

          <Box px={4} pt={4}>
            <NameSearch value={search} onChange={setSearch} />
            <Text fontSize="xs" color="#a7bcaf">Classificação por gols.</Text>
          </Box>
          <TabPanels>
            <TabPanel p={0}>
              {loading && (
                <SimpleGrid columns={{ base: 1, md: 2, xl: 3 }} p={4} gap={3}>
                  {[...Array(6)].map((_, index) => (
                    <Skeleton key={index} height="96px" borderRadius="16px" startColor="#1b2a22" endColor="#283e31" />
                  ))}
                </SimpleGrid>
              )}

              {!loading &&
                !error &&
                players?.data &&
                visibleScorers.length > 0 && (
                  <SimpleGrid columns={{ base: 1, md: 2, xl: 3 }} p={4} gap={3}>
                    {visibleScorers.map((player) => (
                      <PlayerCard
                        key={player.user_id}
                        name={player?.user_name}
                        goals={parseInt(player?.total_goals)}
                        textGoal="Gols"
                        position={player.rankingPosition}
                      />
                    ))}
                  </SimpleGrid>
                )}

              {!loading && !error && players?.data && visibleScorers.length === 0 && (
                <Box textAlign="center" mt={4}>
                  <Text fontWeight="bold">Nenhum jogador encontrado.</Text>
                </Box>
              )}
            </TabPanel>

            <TabPanel p={0}>
              {ownGoalsLoading && (
                <Box role="status" aria-label="Carregando gols contra">
                  <SimpleGrid columns={{ base: 1, md: 2, xl: 3 }} p={4} gap={3}>
                    {[0, 1, 2].map((index) => (
                      <Skeleton key={index} height="96px" borderRadius="16px" startColor="#1b2a22" endColor="#283e31" />
                    ))}
                  </SimpleGrid>
                </Box>
              )}
              {ownGoalsError && (
                <Box textAlign="center" p={4} role="alert">
                  <Text>{ownGoalsError}</Text>
                  <Button mt={3} onClick={retryOwnGoals}>Tentar novamente</Button>
                </Box>
              )}
              {!ownGoalsLoading && !ownGoalsError && ownGoals && visibleOwnGoals.length === 0 && (
                <Text textAlign="center" p={4}>{search.trim() ? "Nenhum jogador encontrado para essa pesquisa." : "Nenhum gol contra registrado."}</Text>
              )}
              {!ownGoalsLoading &&
                !ownGoalsError &&
                ownGoals &&
                visibleOwnGoals.length > 0 && (
                  <SimpleGrid columns={{ base: 1, md: 2, xl: 3 }} p={4} gap={3}>
                    {visibleOwnGoals.map((player) => (
                      <PlayerCard
                        key={player.user_id}
                        name={player?.user_name}
                        goals={parseInt(player?.total_own_goals)}
                        textGoal="Gols contra"
                        position={player.rankingPosition}
                        ownGoal={true}
                      />
                    ))}
                  </SimpleGrid>
                )}
            </TabPanel>
          </TabPanels>
        </Tabs>
      ) : (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          minH="60vh"
          p={4}
        >
          <Box textAlign="center">
            <Box display="flex" justifyContent="center" mb={4}>
              <Icon as={FaFutbol} boxSize={14} color="green.500" mr={3} />
            </Box>
            <Text fontWeight="bold" mt={4}>
              Ranking de jogadores está indisponível no momento.
            </Text>
            <Text fontWeight="medium" mt={4}>
              Em breve, traremos muitas novidades!
            </Text>
          </Box>
        </Box>
      )}
    </Layout>
  );
};
